import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import me from './me';
import jobs from './jobs';
import cvs from './cvs';
import app from './app';
import cvsEditor from './cvsEditor'
import cv from './cv';
//简历编辑
import editor from './editor';
// 经历库
import experience from './experience';
// 模块管理
import manage from './manage';
// 公共模块
import global from './global';

// 职业规划
import planning from "./planning"

const store = new Vuex.Store({
  modules: {
    app,
    me,
    jobs,
    cvs,
    cvsEditor,
    cv,
    editor,
    experience,
    manage,
    global,
    planning
  }
})

export default store;
